import { useState } from 'react';

export default function Industries() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const industries = [
    {
      title: 'Financial Services & Lending',
      description: 'Automation systems for borrower workflows, reporting pipelines, and client onboarding.',
      icon: 'ri-bank-line'
    },
    {
      title: 'Healthcare & Med Spas',
      description: 'Automated scheduling, intake workflows, marketing follow-ups, and internal reporting.',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Clinical Healthcare Practices',
      description: 'Administrative automation that reduces staff burden and improves operational clarity.',
      icon: 'ri-hospital-line'
    },
    {
      title: 'Professional Services & Law',
      description: 'Workflow automation for case management, client communication, and document handling.',
      icon: 'ri-briefcase-line'
    },
    {
      title: 'Real Estate & Property Development',
      description: 'Systems that automate project coordination, investor reporting, and property workflows.',
      icon: 'ri-building-line'
    }
  ];

  return (
    <section className="relative bg-[#1A1C1E] py-32 overflow-hidden">
      {/* Geometric patterns background */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <defs>
            <pattern id="geometricPattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <rect x="0" y="0" width="40" height="40" fill="none" stroke="#00E5FF" strokeWidth="0.5"/>
              <rect x="40" y="40" width="40" height="40" fill="none" stroke="#00E5FF" strokeWidth="0.5"/>
              <circle cx="40" cy="40" r="3" fill="#00E5FF" opacity="0.3"/>
            </pattern>
          </defs>
          <rect width="1000" height="1000" fill="url(#geometricPattern)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#F4F7F6] mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Designed for Operationally Complex Industries
          </h2>
          <p className="text-xl text-[#7F8C8D] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Graystone AI builds automation systems for industries where operational precision is essential.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {industries.map((industry, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className="relative group cursor-pointer"
            >
              <div 
                className="relative bg-[#1A1C1E] border rounded-lg p-8 h-full transition-all duration-300"
                style={{
                  borderColor: hoveredCard === index ? '#00E5FF' : 'rgba(0, 229, 255, 0.3)',
                  borderWidth: '1px',
                  boxShadow: hoveredCard === index ? '0 0 25px rgba(0, 229, 255, 0.3)' : 'none',
                  transform: hoveredCard === index ? 'translateY(-4px)' : 'translateY(0)'
                }}
              >
                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i 
                    className={`${industry.icon} text-3xl transition-all duration-300`}
                    style={{
                      color: hoveredCard === index ? '#00E5FF' : '#7F8C8D'
                    }}
                  ></i>
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-[#F4F7F6] mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {industry.title}
                </h3>
                <p className="text-[#7F8C8D] text-sm leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}